import { useEffect, useState } from "react";

const QUERY = "(max-width: 767px)";

export function useIsPhone() {
  const [phone, setPhone] = useState(() => window.matchMedia(QUERY).matches);
  useEffect(() => {
    const m = window.matchMedia(QUERY);
    const on = () => setPhone(m.matches);
    m.addEventListener("change", on);
    return () => { m.removeEventListener("change", on); };
  }, []);
  return phone;
}
